import { IDefineCommand } from 'core-ts-types';
import { ICommand } from 'core-ts-types';
import { AccountModel } from 'data-ng-authentication';

/**
 *
 */
const universitiesAllowedToAutoAcceptTOU = ['si-umich'];

angular
  .module('lib')
  .service(
    'autoAcceptTOUCommand',
    (defineCommandORM: IDefineCommand, acceptTOUCommand: ICommand, accountModel: AccountModel) => {
      return defineCommandORM('autoAcceptTOUCommand', (deferred) => {
        const isPartnerAllowedToAutoAcceptTOU = universitiesAllowedToAutoAcceptTOU.includes(accountModel.partner_nk);
        if (!isPartnerAllowedToAutoAcceptTOU) {
          return deferred.resolve();
        }

        acceptTOUCommand().then(() => {
          deferred.resolve();
        });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/lib/tos/commands/auto_accept_tou_command.ts